import PropTypes from 'prop-types';
import { panelGroup } from '../../../../shared/constants';
import PanelPropTypes from '../panel/panelPropTypes';

const PanelGroupPropTypes = {
  id: PropTypes.oneOf(Object.values(panelGroup)),
  config: PropTypes.shape({
    maxPanels: PropTypes.number,
  }),
  panels: PropTypes.arrayOf(PropTypes.shape(PanelPropTypes)),
  offset: PropTypes.number,
};

export default PanelGroupPropTypes;
